// Auth-native delegation shapes. The auth service keys delegations on account
// UUIDs and returns no display name, so the UI identifies a delegator by a short,
// stable label derived from the account id.

export interface Delegate {
  id: string;
  delegator_account_id: string;
  delegate_account_id: string | null;
  permissions: string[];
  is_active: boolean;
  status: 'active' | 'pending';
  created_at: string;
  activated_at: string | null;
}

/** Short, human-scannable label for a delegator account that has no display name. */
export const formatDelegatorLabel = (accountId: string): string => `notanda ${accountId.slice(0, 8)}`;
